import type { ReactNode } from "react";

export const projectFormInputClassName =
  "w-full h-9 text-xl border border-slate-300 rounded-lg focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:border-blue-500 placeholder:text-[#818181]";

export const projectFormSelectTriggerClassName =
  "w-full h-9 text-xl border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

export const projectFormFieldStyle = {
  fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontSize: "20px",
} as const;

interface ProjectFormCardLayoutProps {
  actions?: ReactNode;
  leftColumn: ReactNode;
  rightColumn: ReactNode;
}

export function ProjectFormCardLayout({
  actions,
  leftColumn,
  rightColumn,
}: ProjectFormCardLayoutProps) {
  return (
    <div className="p-4 pt-2 -mt-[8px]">
      <div className="max-w-[1112px]">
        <div className="card-container card-container-muted card-container-no-shadow p-[32px]">
          {actions ? <div className="flex items-center justify-end gap-2 mb-4">{actions}</div> : null}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">{leftColumn}</div>
            <div className="space-y-6">{rightColumn}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
